<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact lv-zeitraum-container" [ngClass]="uiArtefakt?.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt?.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt?.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt?.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt?.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt?.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>

    <div class="lv-zeitraum">
      <div class="lv-zeitraum-item">
        <mat-form-field>
          <div [ngClass]="{'lv-input-field': true, 'lv-material-form-input': true, 'lv-error-state-zeitraum': !!getError()}" color="accent">
            <mat-select #jahresControl="ngModel" (valueChange)="changeJahre($event)" [name]="'jahreDropdown'"
                        [hideSingleSelectionIndicator]="true" [ngModel]="jahr">
              <mat-option *ngFor="let jahr of jahre"
                          [value]="jahr"
                          class="lv-mat-option-multiline">
                {{jahr}} {{getJahresUnit(jahr)}}
              </mat-option>
            </mat-select>
          </div>
        </mat-form-field>
      </div>
      <div class="lv-zeitraum-item">
        <mat-form-field>
          <div [ngClass]="{'lv-input-field': true, 'lv-material-form-input': true, 'lv-error-state-zeitraum': !!getError()}" color="accent">
            <mat-select #monatsControl="ngModel" (valueChange)="changeMonate($event)" [name]="'monateDropdown'"
                        [hideSingleSelectionIndicator]="true" [ngModel]="monat" [disabled]="model >= uiArtefakt?.WertEingabeMax">
              <mat-option *ngFor="let monat of monate"
                          [value]="monat"
                          class="lv-mat-option-multiline">
                {{monat}} {{getMonatsUnit(monat)}}
              </mat-option>
            </mat-select>
          </div>
        </mat-form-field>
        <input [name]="'lvHidden'" [(ngModel)]="model" class="lv-hidden-model" [required]="uiArtefakt?.PflichtfeldJN">
      </div>
    </div>

    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt?.InfoTextPermanent"></lv-infotext-permanent>
    <div>
      <mat-error class="lv-error-meldung-style-zeitraum" [ngClass]="uiArtefakt.BreiteInPixel"
                 *ngIf="getError() as error" (click)="onErrorClick()">
        <div class="lv-control-error"
             [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
      </mat-error>
    </div>
  </div>
</form>
